import React, { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useWindowContext } from "../../../contexts";
import { Typography } from "../../../ui/components/typography/Typography";
import { nxmPanelClose, nxmPanelOpen, } from "../../../ui/icon-paths";
import { activeProfile as activeProfileSelector, gameProfiles as gameProfilesSelector, knownGames as knownGamesSelector, } from "../../../util/selectors";
import { useSpineContext } from "../Spine/SpineContext";
import { HelpSection } from "./HelpSection";
import { IconButton } from "./IconButton";
import { Notifications } from "./Notifications";
import { PremiumIndicator } from "./PremiumIndicator";
import { ProfileSection } from "./ProfileSection";
import { WindowControls } from "./WindowControls";
export const Header = () => {
    const { menuIsCollapsed, setMenuIsCollapsed } = useWindowContext();
    const { t } = useTranslation();
    const { selection } = useSpineContext();
    const knownGames = useSelector(knownGamesSelector);
    const activeProfile = useSelector(activeProfileSelector);
    const gameProfiles = useSelector(gameProfilesSelector);
    const title = useMemo(() => {
        if (selection.type === "home") {
            return t("Home");
        }
        if (selection.type === "downloads") {
            return t("Downloads");
        }
        const game = knownGames.find((g) => g.id === selection.gameId);
        return game?.name ?? t("Home");
    }, [selection, knownGames, t]);
    const handleToggleMenu = useCallback(() => {
        setMenuIsCollapsed((prev) => !prev);
    }, [setMenuIsCollapsed]);
    const profileName = useMemo(() => {
        if (selection.type !== "game" || !activeProfile) {
            return undefined;
        }
        return gameProfiles.length > 1 ? activeProfile.name : undefined;
    }, [selection, activeProfile, gameProfiles]);
    return (React.createElement("div", { className: "flex h-11 items-center justify-between overflow-hidden pl-4.5", style: { WebkitAppRegion: "drag" } },
        React.createElement("div", { className: "flex min-w-0 flex-1 items-center gap-x-1 overflow-hidden", style: { WebkitAppRegion: "no-drag" } },
            React.createElement(IconButton, { appearance: "secondary", iconPath: menuIsCollapsed ? nxmPanelOpen : nxmPanelClose, title: menuIsCollapsed ? "Open menu" : "Collapse menu", onClick: handleToggleMenu }),
            React.createElement(Typography, { appearance: "none", className: "flex min-w-0 items-center gap-x-2 truncate font-semibold" },
                React.createElement("span", { className: "shrink-0 text-neutral-strong" }, title),
                profileName && (React.createElement("span", { className: "min-w-0 max-w-[33%] truncate text-neutral-subdued" }, profileName)))),
        React.createElement("div", { className: "flex shrink-0 items-center gap-x-4", style: { WebkitAppRegion: "no-drag" } },
            React.createElement(PremiumIndicator, null),
            React.createElement("div", { className: "flex gap-x-2" },
                React.createElement(Notifications, null),
                React.createElement(HelpSection, null),
                React.createElement(ProfileSection, null)),
            React.createElement("div", { className: "h-6 w-px bg-stroke-weak" }),
            React.createElement(WindowControls, null))));
};
